/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_CarddetailsInputs */

const en_visa_eb3_carddetails = /** @type {(inputs: Visa_Eb3_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment-based immigrant classification generally tied to a permanent, full-time U.S. job offer and category-specific requirements.`)
};

const pt_visa_eb3_carddetails = /** @type {(inputs: Visa_Eb3_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação imigratória baseada em emprego geralmente ligada a uma oferta permanente de trabalho em tempo integral nos EUA e requisitos específicos da categoria.`)
};

const es_visa_eb3_carddetails = /** @type {(inputs: Visa_Eb3_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación migratoria basada en empleo generalmente vinculada a una oferta permanente de trabajo a tiempo completo en EE. UU. y requisitos específicos de la categoría.`)
};

/**
* | output |
* | --- |
* | "Employment-based immigrant classification generally tied to a permanent, full-time U.S. job offer and category-specific requirements." |
*
* @param {Visa_Eb3_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_carddetails = /** @type {((inputs?: Visa_Eb3_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_carddetails(inputs)
	if (locale === "es") return es_visa_eb3_carddetails(inputs)
	return en_visa_eb3_carddetails(inputs)
});